import React from 'react';

interface LoadingProps {
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({ className = '' }) => {
  return (
    <div className={`loading ${className}`}>
      <div className="loading__dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loading; 